// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"7":"1c360a98","51":"1b2ed835"}[chunkId] + ".chunk.js");